export default {
  $_setToken(state, value) {
    // 设置存储token
    state.token = value;
    sessionStorage.setItem("token", value);

    console.log(123);
  },

  $_removeStorage(state) {
    state.token = '';
    // 删除token
    sessionStorage.removeItem("token");
  },

  $_setElevatorList(state, value) {
    // 设置存储电梯列表
    state.elevatorList = value;
  },

  $_setWarningList(state, value) {
    // 设置存储异常列表
    state.warningList = value;
  },

  $_setCurElevatorInfo(state, value) {
    // 设置当前选中电梯信息
    state.curElevatorId = value.id;
    state.curElevatorInfo = value.code + '-' + value.remark;
    state.curElevatorType = value.type;
  },

  $_setCurSensorList(state, value) {
    // 设置当前传感器列表
    state.curSensorList = value
  },

  $_setSensorClassificationList(state, value) {
    // 设置当前传感器列表
    state.sensorClassificationList = value
  },

  $_setAngleEchartData(state, value) {
    // 设置倾角数据
    state.angleEchartData = value
  },

  $_setMileageEchartData(state, value) {
    // 设置里程数据
    state.mileageEchartData = value
  },

  $_setSpeedEchartData(state, value) {
    // 设置速度数据
    state.speedEchartData = value
  },

  $_setMotorEchartData(state, value) {
    // 设置电机数据
    state.motorEchartData = value
  },

  $_setPerEchartData(state, value) {
    // 设置电机数据
    state.perEchartData = value

  },
  SET_USER(state, value) {
    state.userInfo = value;

  },
}


// WEBPACK FOOTER //
// ./src/store/mutations.js